import script from "./moneyManage.vue?vue&type=script&setup=true&lang=js"
export * from "./moneyManage.vue?vue&type=script&setup=true&lang=js"

import "./moneyManage.vue?vue&type=style&index=0&id=75808d0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75808d0b"]])

export default __exports__